import { TriangleAlert } from 'lucide-react';

import { Alert, AlertDescription } from '@apps/web/components/ui/alert';
import { collectClientIdentifyingTemplateVariables } from '@apps/web/lib/client_identifying_template_variables';

const CLIENT_IDENTIFYING_INFO_WARNING =
    'Note: SMS messages are not encrypted. Keep messages general and avoid ' +
    'identifying details about clients or caregivers.';

type ClientIdentifyingInfoWarningProps = {
    readonly templates: ReadonlyArray<string>;
};

/** Warn while an SMS template contains a client-identifying variable. */
export function ClientIdentifyingInfoWarning({
    templates,
}: ClientIdentifyingInfoWarningProps) {
    const identifyingVariables =
        collectClientIdentifyingTemplateVariables(templates);

    if (identifyingVariables.length === 0) {
        return null;
    }

    return (
        <Alert className="rounded-md border-amber-300 bg-amber-50 px-3 py-2 text-amber-950 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200">
            <TriangleAlert className="text-amber-600 dark:text-amber-400" />
            <AlertDescription className="space-y-1 text-xs font-medium text-amber-950 sm:text-sm dark:text-amber-200">
                <p>{CLIENT_IDENTIFYING_INFO_WARNING}</p>
                <p>
                    {`Identifying variables used: ${identifyingVariables
                        .map((variable) => `{${variable}}`)
                        .join(', ')}`}
                </p>
            </AlertDescription>
        </Alert>
    );
}
